export default __webpack_public_path__ + "static/media/delivery.8acdc85a.webp";